/**
 * @module enum
 */
export enum GroupAddOptEnum {
    /**
     * 禁止加群
     */
    V2TIM_GROUP_ADD_FORBID,
    /**
     * 需要管理员审批
     */
    V2TIM_GROUP_ADD_AUTH,
    /**
     * 任何人可以加入
     */
    V2TIM_GROUP_ADD_ANY,
}
